import { useMediaQuery } from '@material-ui/core';
import BarCodeIcon from 'images/icons/barCodes/barCodeDarkGrayOutline.svg';
import BarCodeActiveIcon from 'images/icons/barCodes/barCodeWhiteOutline.svg';
import { useState } from 'react';
import { ValidityFilterBox } from '../../styles';

function ValidityFilter({
  onClick,
  initialActive = [],
  validityFilterInfos,
  filterOpen,
}) {
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const isMobileScreen = useMediaQuery('(max-width: 866px)');
  const expiredInfos = validityFilterInfos?.content?.find(
    (filter) => filter?.labelStatus === 'EXPIRED'
  );
  const onDateInfos = validityFilterInfos?.content?.find(
    (filter) => filter?.labelStatus === 'ON_DATE'
  );
  const validInfos = validityFilterInfos?.content?.find(
    (filter) => filter?.labelStatus === 'VALID'
  );
  const [activeFilters, setActiveFilters] = useState(initialActive || []);

  const FILTERS = [
    {
      label: 'ONTEM',
      key: 'EXPIRED',
      colorClass: 'expired',
      total: expiredInfos?.total || 0
    },
    {
      label: 'HOJE',
      key: 'ON_DATE',
      colorClass: 'onDate',
      total: onDateInfos?.total || 0
    },
    {
      label: 'AMANHÃ',
      key: 'VALID',
      colorClass: 'valid',
      total: validInfos?.total || 0
    }
  ];

  const buildTotalValueText = (filter) => {
    let text = `${filter.label}: ${filter?.total}`;

    if (isMobileScreen) text = `QTDE: ${filter?.total}`;

    if (isPhoneScreen) text = filter?.total;

    return text;
  };

  const handleToggle = (key) => {
    const isActive = activeFilters.includes(key);
    const newFilters = isActive
      ? activeFilters.filter((f) => f !== key)
      : [...activeFilters, key];

    setActiveFilters(newFilters);
    onClick?.(newFilters);
  };

  return (
    <ValidityFilterBox filterOpen={filterOpen}>
      {FILTERS.map((filter) => {
        const isActive = activeFilters.includes(filter.key);

        return (
          <div
            key={filter.key}
            className={`validityCard ${filter.colorClass} ${
              isActive ? 'active' : ''
            }`}
            onClick={() => {
              handleToggle(filter.key)
            }}
          >
            <p className="title">
              {isMobileScreen ? filter?.label : 'VENCIMENTO'}
            </p>

            <div className="labelAndValue">
              {buildTotalValueText(filter)}

              <img
                style={{ width: '20px' }}
                src={isActive ? BarCodeActiveIcon : BarCodeIcon}
                alt="BarCodeIcon"
              />
            </div>
          </div>
        );
      })}
    </ValidityFilterBox>
  );
}

export default ValidityFilter;
